import { render, staticRenderFns } from "./ExcludedList.vue?vue&type=template&id=4cb42009"
import script from "./ExcludedList.vue?vue&type=script&lang=js"
export * from "./ExcludedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports